import Button from 'components/core/button'
import IconButton from 'lib/components/buttons/icon-button'
import Modal, { BaseModalProps } from 'lib/components/modals/modal'
import { X } from 'lucide-react'
import BillingModalPeriod from './billing-modal-period'
import BillingModalPlatform from './billing-modal-platform'
import BillingModalProfessionalServices from './billing-modal-professional-services'
import BillingModalCreativeServices from './billing-modal-creative-services'
import { useState } from 'react'
import BillingModalReview from './billing-modal-review'
import { useBillingPlans } from './billing-plans-context'

export default function BillingModal({
  open,
  setOpen,
}: {
  open: BaseModalProps['open']
  setOpen: BaseModalProps['setOpen']
}) {
  const { currentSubscriptions, selectedPlans } = useBillingPlans()
  const [review, setReview] = useState(false)
  const disabled =
    currentSubscriptions?.creativeSubscription?.picklePlan?.id === selectedPlans?.creativePlan?.id &&
    currentSubscriptions?.platformSubscription?.picklePlan?.id === selectedPlans?.platformPlan?.id &&
    currentSubscriptions?.professionalSubscription?.picklePlan?.id === selectedPlans?.professionalPlan?.id

  return (
    <Modal open={open} setOpen={setOpen} size="lg">
      <Modal.Header as="div">
        <div className="tw-flex tw-items-center tw-justify-between">
          <h4>Manage Subscription</h4>
          <IconButton color="secondary" onClick={() => setOpen(false)} data-testid="close-modal-button">
            <X />
          </IconButton>
        </div>
      </Modal.Header>

      <Modal.Body>
        {review ? (
          <BillingModalReview />
        ) : (
          <div className="tw-flex tw-flex-col tw-gap-4">
            <BillingModalPeriod />
            <BillingModalPlatform />
            <div className="tw-font-semibold">Services</div>
            <BillingModalCreativeServices />
            <BillingModalProfessionalServices />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div className="tw-mt-8 tw-flex tw-w-full tw-justify-between">
          <Button color="neutral" onClick={() => console.log('Cancel subscription')}>
            Cancel Subscription
          </Button>
          {review ? (
            <div className="tw-flex tw-justify-end">
              <Button color="neutral" onClick={() => setReview(false)} className="tw-mr-2">
                Go Back
              </Button>
              <Button color="purple" onClick={() => console.log('Confirm changes')}>
                Confirm changes
              </Button>
            </div>
          ) : (
            <div className="tw-flex tw-justify-end">
              <Button
                color="neutral"
                onClick={() => {
                  setOpen(false)
                }}
                className="tw-mr-2"
              >
                Cancel
              </Button>
              <Button color="purple" onClick={() => setReview(true)} disabled={disabled}>
                Review changes
              </Button>
            </div>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  )
}
